export const projectContractAddress = "0x738084823ca6966532Ffb446c0bea160F4872Cb3";
export const subContractAddress = "0xe9e7cea3dedca5984780bafc599bd69add087d56";

// export const projectContractAddress = "0xf06fb1F025AE0B5D2a8519EBFF8Af2fee2c1Ee75";
// export const subContractAddress = "0xbE04fb4f3E3220C6A3c7Ea0f65969ef1E150bBF4";